import {
    cmdDeviceDesktop,
    cmdDeviceTablet,
    cmdDeviceMobile,
    cmdClear,
    cmdHelp,
    cmdSettings,
    cmdTools,
    cmdWebsite,
    cmdUpgrade,
    cmdPreview
} from '../consts';
import help from './help';
import settings from './settings';
import tools from './tools';
import website from './website';
import upgrade from './upgrade';
import preview from './preview';

export default (editor, opts = {}) => {
    const cm = editor.Commands;
    const txtConfirm = opts.txtConfirmClear;
    const pfx = editor.getConfig().stylePrefix;
    const modal = editor.Modal;
    const mdlClass = `${pfx}mdl-dialog-sm`;
    let mdlClear;

    cm.add(cmdHelp, () => help(editor, opts));
    cm.add(cmdSettings, () => settings(editor, opts));
    cm.add(cmdTools, () => tools(editor, opts));
    cm.add(cmdWebsite, () => website(editor, opts));
    cm.add(cmdUpgrade, () => upgrade(editor, opts));
    cm.add(cmdPreview, () => preview(editor, opts));

    cm.add(cmdClear, () => {
        const mdlDialog = modal.getContentEl().parentElement.parentElement;
        mdlDialog.className += ' ' + mdlClass;
        modal.setTitle('<div>Canvas</div>');
        mdlClear = mdlClear ? mdlClear : document.createElement('div');
        if (!mdlClear.innerHTML) {
            mdlClear.innerHTML = `<div style="font-size:15px;">${txtConfirm}</div><br>`;
            const b = document.createElement('button');
            b.className += `${pfx}btn-prim`;
            b.innerHTML = "Clear";
            b.addEventListener('click', () => {
                const selected = editor.getSelectedAll();
                selected && editor.selectRemove(selected);
                editor.runCommand('core:canvas-clear');
                editor.Modal.close();
            });
            mdlClear.appendChild(b);
        }
        modal.setContent(mdlClear);
        modal.open();
        modal.getModel().once('change:open', function () {
            mdlDialog.className = mdlDialog.className.replace(mdlClass, '');
        });
    });
    //? commands icon based devices panel
    cm.add(cmdDeviceDesktop, {
        run: function (ed) {
            ed.setDevice('Desktop');
            const selected = editor.getSelectedAll();
            selected && editor.selectRemove(selected);
        },
        stop: function () {},
    });
    cm.add(cmdDeviceTablet, {
        run: function (ed) {
            ed.setDevice('Tablet');
            const selected = editor.getSelectedAll();
            selected && editor.selectRemove(selected);
        },
        stop: function () {},
    });
    cm.add(cmdDeviceMobile, {
        run: function (ed) {
            ed.setDevice('Mobile portrait');
            const selected = editor.getSelectedAll();
            selected && editor.selectRemove(selected);
        },
        stop: function () {},
    });
}